const messages = {
  title: "Lavori di manutenzione!",
  description:
    'Sono in corso i necessari lavori di manutenzione dei server.<br/><br/>Pertanto, l\'accesso a <b>BRIDGESTONE <span class="text-danger">PLUS</span></b> non è attualmente disponibile.<br/><br/>Vi chiediamo di avere pazienza e vi ringraziamo per la vostra comprensione.<br/><br/> Il vostro team Bridgestone',
}
export default {
  messages
}
